import { ResourceType } from '../../shared/resource-type';

export const WORKSPACEITEM = new ResourceType('workspaceitem');
